import { Link } from '@tanstack/react-router';

type SettingsNavSubItemProps = {
  to: string;
  label: string;
  /** `true` quando outra página do mesmo item fica abaixo deste caminho. */
  exact?: boolean;
};

const BASE_CLASSES =
  'flex items-center rounded-xl px-3 py-1.5 text-xs transition-colors lg:ml-7';

/** Subitem de uma seção do menu de Configurações (ex.: Produtos › Formas de pagamento). */
export function SettingsNavSubItem({
  to,
  label,
  exact = false,
}: SettingsNavSubItemProps) {
  return (
    <Link
      to={to}
      activeOptions={{ exact, includeSearch: false }}
      activeProps={{
        className: `${BASE_CLASSES} bg-alba-gray-200 font-semibold text-alba-blue-500`,
      }}
      inactiveProps={{
        className: `${BASE_CLASSES} text-alba-gray-600 hover:bg-alba-gray-200`,
      }}
    >
      {label}
    </Link>
  );
}
